import annaRozanova from './Anna-Rozanova.jpg';
import oleksandrKovalenko from './Oleksandr-Kovalenko.jpg';
import olenaNevzorova from './Olena-Nevzorova.jpg';
import olhaShtokalo from './Olha-Shtokalo.jpg';
import serhiiSokoliuk from './Serhii-Sokoliuk.jpg';
import timothyZalishchuk from './Timothy-Zalishchuk.jpg';

export const qaTeamImgs = [
  timothyZalishchuk,
  annaRozanova,
  oleksandrKovalenko,
  olenaNevzorova,
  olhaShtokalo,
  serhiiSokoliuk
];